import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslator, formatMediumDate } from '@front-activerse/common-components';
import { biometricSettings } from '../types';

export const Summary: React.FC = () => {
  const { t } = useTranslator();
  const { values } = useFormikContext<biometricSettings>();
  const { sex, heightValue, heightUnit, dateOfBirth } = values;

  const decimalSeparator = () => {
    const n = 1.1;
    const separator = n.toLocaleString().substring(1, 2);
    return separator;
  };

  return (
    <>
      <h2 className="mb-m title-large semi-bold">{t('biometric.summary.headline')}</h2>
      <p className="mb-xl text-text-variant-color">{t('biometric.summary.description')}</p>

      <div>
        <dl>
          <dt>{t('biometric.summary.list.gender')}</dt>
          <dd>{t(`biometric.summary.list.gender.${sex}`)}</dd>
        </dl>

        <dl>
          <dt>{t('biometric.summary.list.birthDate')}</dt>
          <dd>{formatMediumDate(dateOfBirth)}</dd>
        </dl>

        <dl>
          <dt>{t('biometric.summary.list.height')}</dt>
          <dd>
            {String(heightValue).replace('.', decimalSeparator())} {heightUnit}
          </dd>
        </dl>
      </div>
    </>
  );
};

export default Summary;
